import React, { useEffect, useState } from 'react';

import ContactAddressEdit from '@components/shared/contact_addresses/ContactAddressEdit';

import { contactAddressService } from '@services/admin/contactAddressService';
import { salesChannelService } from '@services/admin/salesChannelService';

interface SalesChannel {
  id: string;
  name: string;
  [key: string]: unknown;
}

const AdminContactAddressNew: React.FC = () => {
  const [salesChannels, setSalesChannels] = useState<SalesChannel[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const data = await salesChannelService.list({});
        if (data?.success && Array.isArray(data.data)) {
          setSalesChannels(data.data as SalesChannel[]);
        }
      } catch (error) {
        console.error('Failed to load sales channels:', error);
      }
    })();
  }, []);

  return (
    <ContactAddressEdit
      contactAddressService={contactAddressService}
      role="admin"
      salesChannels={salesChannels}
    />
  );
};

export default AdminContactAddressNew;
